import { useEffect, useState, type ReactElement } from 'react';

export function DuelCrowdPreview(): ReactElement {
  const [mounted, setMounted] = useState(false);

  useEffect(() => {
    const t = setTimeout(() => setMounted(true), 60);
    return () => clearTimeout(t);
  }, []);

  const left = mounted ? 41 : 0;
  const right = mounted ? 58 : 0;

  return (
    <div className="rounded-2xl border-2 border-primary/25 bg-card p-4 shadow-[var(--shadow-card)]">
      <div className="text-[10px] font-semibold uppercase tracking-wide text-muted-foreground mb-3 text-center">
        Live Crowd
      </div>
      <div className="grid grid-cols-[1fr_auto_1fr] items-stretch gap-2">
        <div className="rounded-xl bg-primary/5 border border-primary/20 p-3.5 text-center flex flex-col justify-center">
          <div className="text-lg font-bold">Saka</div>
          <div className="text-[10px] text-muted-foreground">ARS</div>
          <div className="mt-2 text-3xl font-extrabold text-primary tabular-nums">{left}%</div>
          <div className="mt-1 h-1 rounded-full bg-primary/20 overflow-hidden">
            <div
              className="h-full bg-primary motion-safe:transition-[width] motion-safe:duration-[450ms] motion-safe:ease-in-out"
              style={{ width: `${left}%` }}
            />
          </div>
        </div>
        <div className="flex items-center text-[10px] font-bold text-muted-foreground">VS</div>
        <div className="rounded-xl bg-competitive-blue/5 border border-competitive-blue/30 p-3.5 text-center flex flex-col justify-center">
          <div className="text-lg font-bold">Palmer</div>
          <div className="text-[10px] text-muted-foreground">CHE</div>
          <div className="mt-2 text-3xl font-extrabold text-competitive-blue tabular-nums">{right}%</div>
          <div className="mt-1 h-1 rounded-full bg-competitive-blue/20 overflow-hidden">
            <div
              className="h-full bg-competitive-blue motion-safe:transition-[width] motion-safe:duration-[450ms] motion-safe:ease-in-out"
              style={{ width: `${right}%` }}
            />
          </div>
        </div>
      </div>
    </div>
  );
}
